import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from './AxiosBaseQuery';
import { V3_APP_BASE_URL } from '@/constants/Config';
import {
  applyPrintConfigPatternIds,
  type IPrintConfigDecoratingMethod,
} from '@/utilities/PrintConfigPatternIdsUtils';

export interface IPrintConfigData {
  printTypes?: unknown[];
  decoratingMethods?: IPrintConfigDecoratingMethod[];
  printTypesMap?: Record<string, unknown>;
  decoratingMethodsMap?: Record<string, unknown>;
}

export interface IPrintConfigQueryParams {
  context?: string;
}

export const applyPrintConfigCatalog = (data: IPrintConfigData | null | undefined): void => {
  applyPrintConfigPatternIds(data?.decoratingMethods);
};

export const printConfigQuery = createApi({
  reducerPath: 'printConfigQuery',
  baseQuery: axiosBaseQuery({
    baseUrl: V3_APP_BASE_URL,
  }),
  keepUnusedDataFor: 60 * 60,
  endpoints: (build) => ({
    getPrintConfig: build.query<IPrintConfigData, void | IPrintConfigQueryParams>({
      query: (arg) => ({
        url: 'api/v4/print-config',
        method: 'get',
        params: arg?.context ? { context: arg.context } : undefined,
      }),
      async onQueryStarted(_arg, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          applyPrintConfigCatalog(data);
        } catch {
          /* Keep fallback CMS ids until a later request succeeds. */
        }
      },
    }),
  }),
});

export const { useGetPrintConfigQuery, useLazyGetPrintConfigQuery } = printConfigQuery;
